export default __webpack_public_path__ + "static/media/487.1c8a6197.jpg";